import React, {useState, forwardRef, useImperativeHandle, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {Modal, List} from 'antd';
import _ from 'lodash';
import {switchChatRecord} from './Utils';
import styles from './card.module.less';

const ChatRecordModal = forwardRef(({chatRecords}, ref) => {
    useImperativeHandle(ref, () => ({
        open,
    }));
    const [visible, setVisible] = useState(false);

    function open() {
        setVisible(true);
    }

    function handleCancel() {
        setVisible(false);
    }

    function handleOk() {
        setVisible(false);
    }

    return (
        <Modal
            width={'50%'}
            title="群聊记录"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
        >
            <div className={styles.chatRecord}>
                <List
                    itemLayout="horizontal"
                    dataSource={chatRecords}
                    renderItem={item => (
                        <List.Item className={styles.content}>
                            <div>{switchChatRecord(item).temp}</div>
                        </List.Item>
                    )}
                />
            </div>
        </Modal>
    );
});

ChatRecordModal.displayName = 'ChatRecordModal';

export default ChatRecordModal;
